// src/routes/AppRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import AdminDashboard from '../components/AdminDashboard';
import Login from '../pages/Login/Login';
import Register from '../pages/Register/Register';
import AuthCallback from '../pages/Register/AuthCallback';
import { useAuth } from '../contexts/AuthContext';
import Contacto from '../pages/Dashboard/Contacto';
import RecuperarContraseña from '../pages/RecuperarContraseña/RecuperarContraseña';
import ActualizarContraseña from '../pages/RecuperarContraseña/ActualizarContraseña';

const AppRoutes = () => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return <div>Cargando...</div>;
  }

  // Determinar la redirección post-login según el rol
  const defaultRoute = isAdmin ? '/admin' : '/dashboard';

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={!user ? <Login /> : <Navigate to={defaultRoute} />} />
      <Route path="/register" element={<Register />} />
      <Route path="/contacto" element={<Contacto />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/recuperar-contraseña" element={<RecuperarContraseña />} />
      <Route path="/actualizar-contraseña" element={<ActualizarContraseña />} />

      {/* Rutas del dashboard de cliente */}
      <Route
        path="/dashboard/*"
        element={user && !isAdmin ? <Dashboard /> : <Navigate to={user ? '/admin' : '/login'} />}
      />

      {/* Rutas del panel de administración */}
      <Route
        path="/admin/*"
        element={user && isAdmin ? <AdminDashboard /> : <Navigate to={user ? '/dashboard' : '/login'} />}
      />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
